import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import styles from './password.module.css';
import config from '@config';
const LOCAL_STORAGE_KEY = 'password-authenticated';
export function Password(props: PasswordProps) {
	const [password, setPassword] = useState('');
	const { onSuccess } = props;
	const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (password !== config.app.password.value) {
			toast.error('Wrong password');
			return;
		}
		localStorage.setItem(LOCAL_STORAGE_KEY, config.app.password.value);
		onSuccess();
	};
	const classNames = [styles['view']];
	if (password) {
		classNames.push(styles['show-send']);
	}
	return (
		<div className={classNames.join(' ')}>
			<div>
				<LockIcon />
				<form onSubmit={onSubmit}>
					<input
						title={'Password'}
						value={password}
						type="password"
						minLength={1}
						onChange={(e) => {
							setPassword(e.target.value);
						}}
						required
					/>
					<button
						type={'submit'}
						disabled={password ? undefined : true}
					>
						<SendIcon />
					</button>
				</form>
			</div>
		</div>
	);
}

interface PasswordProps {
	onSuccess: () => void;
}

function LockIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className={styles['lock']}
		>
			<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
			<path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
		</svg>
	);
}

function SendIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className={styles['send']}
		>
			<line x1="22" y1="2" x2="11" y2="13"></line>
			<polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
		</svg>
	);
}

/**
 * React hook that returns if the application should return a password component
 *
 */
export function usePassword(): PasswordResponse {
	const [shouldDisplayPassword, setShouldDisplayPassword] =
		useState<boolean>(true);
	const { password } = config.app;
	useEffect(() => {
		if (!password) {
			setShouldDisplayPassword(false);
			return;
		}
		const { enabled, value } = config.app.password;
		if (!enabled || !value) {
			setShouldDisplayPassword(false);
			return;
		}

		const storageValue = localStorage.getItem(LOCAL_STORAGE_KEY);

		if (!storageValue) {
			setShouldDisplayPassword(true);
			return;
		}

		setShouldDisplayPassword(storageValue !== value);
	}, [password]);

	return {
		shouldDisplayPassword,
		onSuccessPassword: () => {
			setShouldDisplayPassword(false);
		},
	};
}

interface PasswordResponse {
	shouldDisplayPassword: boolean;
	onSuccessPassword: () => void;
}
